__webpack_require__.p = "/inet-gpt/";